/* Price-display fixes for "Featured Collection +" sections.
   Replaces the old per-instance inline script (which polled on 4 timers per
   section) with a single run on DOM ready plus a debounced MutationObserver
   per section to catch AJAX-loaded cards. Sections register themselves via
   window.fcPriceFixQueue before this file executes (it is deferred). */
(function () {
  'use strict';

  if (window.__fcPriceFixInit) return;
  window.__fcPriceFixInit = true;

  function fixPrices(root) {
    var priceContainers = root.querySelectorAll('.modal_price, .price-wrapper, [class*="price"]');
    priceContainers.forEach(function (priceEl) {
      if (priceEl.dataset.priceFixed === 'true') return;

      var html = priceEl.innerHTML;
      var cleaned = html.replace(/\s*\|\s*PRP\s*/gi, '').replace(/\s*\|\s*/g, '');
      if (cleaned !== html) priceEl.innerHTML = cleaned;

      var currentPrice = priceEl.querySelector('.current_price, .price:not(.was_price):not(.compare-at-price), .money');
      var comparePrice = priceEl.querySelector('.was_price, .compare-at-price, [class*="compare"]');

      if (currentPrice) {
        currentPrice.style.display = 'inline-block';
        currentPrice.style.fontSize = '20px';
        currentPrice.style.fontWeight = '700';
      }

      if (comparePrice && comparePrice.textContent.trim() !== '') {
        comparePrice.style.display = 'block';
        comparePrice.style.fontSize = '13px';
        // WCAG AA contrast: full opacity + a dark-enough gray (#595959 ≈ 7:1 on white).
        // The previous opacity:0.7 dropped the struck PRP price to ~2.9:1 (Lighthouse fail).
        comparePrice.style.opacity = '1';
        comparePrice.style.color = '#595959';
        comparePrice.style.marginTop = '4px';
        comparePrice.style.textDecoration = 'line-through';

        var compareText = comparePrice.textContent.trim().replace(/^PRP\s+/gi, '');
        comparePrice.textContent = 'PRP ' + compareText;
      }

      priceEl.dataset.priceFixed = 'true';
      priceEl.style.display = 'block';
    });
  }

  function hideOutOfStock(root) {
    root.querySelectorAll('.thumbnail').forEach(function (product) {
      var text = product.textContent.toLowerCase();
      if (text.indexOf('sold out') !== -1 || text.indexOf('stoc epuizat') !== -1 || text.indexOf('indisponibil') !== -1) {
        product.style.display = 'none';
      }
    });
  }

  function runSection(cfg) {
    var root = document.querySelector('#shopify-section-' + cfg.id);
    if (!root) return;
    fixPrices(root);
    if (cfg.hideOutOfStock) hideOutOfStock(root);
  }

  function init() {
    (window.fcPriceFixQueue || []).forEach(function (cfg) {
      runSection(cfg);

      var root = document.querySelector('#shopify-section-' + cfg.id);
      if (!root || !window.MutationObserver) return;

      var timer = null;
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) {
            clearTimeout(timer);
            timer = setTimeout(function () { runSection(cfg); }, 150);
            return;
          }
        }
      }).observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
